

import { createSlice } from '@reduxjs/toolkit';

const filterCatagorySlice = createSlice({
  name: 'filterCatagoryList',
  initialState: {
    items: [],
  },
  reducers: {
    addItem: (state, action) => {
      state.items.push(action.payload); // add a string
    },
    removeItem: (state, action) => {
      state.items = state.items.filter(item => item !== action.payload); // remove a string
    },
    clearList: (state) => {
      state.items = [];
    }
  },
});

export const { addItem, removeItem, clearList } = filterCatagorySlice.actions;
export default filterCatagorySlice.reducer;
